import React from 'react';
import { useTranslation } from 'react-i18next';

import HelperDate from '../../helpers/HelperDate';

interface IProps {
    followUps: any[];
}

const BaseHistoryFollowUp = ({ followUps }: IProps) => {
    const { t: localizer } = useTranslation();

    return (
        <div className="border card border-dark user-card">
            <div className="bg-transparent card-header">
                <h5 className="my-0 text-dark">
                    <i className="bx bx-history me-3"></i>
                    {localizer('Histórico')}
                </h5>
            </div>
            <div className="card-body">
                <div className="">
                    <ul className="verti-timeline list-unstyled">
                        {
                            followUps?.map((followUp, idx) =>
                                <li key={idx} className={`event-list ${followUp?.active && 'active'}`}>
                                    <div className="event-timeline-dot">
                                        <i className={`bx bx-right-arrow-circle ${followUp?.active && 'bx-fade-right'}`}></i>
                                    </div>
                                    <div className="media">
                                        <div className="media-body">
                                            <div>
                                                <h5 className="font-size-15">
                                                    {followUp?.status?.name}
                                                </h5>
                                                <p>
                                                    {followUp?.description}
                                                </p>
                                                <span className="text-primary">
                                                    {HelperDate.read(followUp?.registerDate)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default BaseHistoryFollowUp;